import vSeparator from './Separator.vue';

export { vSeparator };



// WEBPACK FOOTER //
// ./src/baseComponents/components/Separator/index.js